"use client";
import React, { useContext } from "react";

import BsAccordion, {
  type AccordionProps as BSAccordionProps,
} from "react-bootstrap-v1.6/Accordion";
import { type AccordionCollapseProps } from "react-bootstrap-v1.6/AccordionCollapse";
import { type AccordionToggleProps as BSAccordionToggleProps } from "react-bootstrap-v1.6/AccordionToggle";
import AccordionContext from "react-bootstrap-v1.6/AccordionContext";

import defaultStyles from "./main.module.scss";

export interface AccordionToggleProps extends BSAccordionToggleProps {
  showArrow?: boolean;
  disabled?: boolean;
  baseClass?: string;
  openClass?: string;
  styles?: ModularStyles;
}

export interface AccordionProps extends BSAccordionProps {
  styles?: ModularStyles;
  eventKey: string;
  defaultOpen?: boolean;
}

export const Accordion: React.FC<AccordionProps> = ({
  styles = defaultStyles,
  eventKey,
  defaultOpen = false,
  ...props
}) => (
  <BsAccordion
    {...(BsAccordion.defaultProps || {})}
    defaultActiveKey={defaultOpen ? eventKey : ""}
    bsPrefix={styles.accordion}
    {...props}
  />
);

export const AccordionToggle: React.FC<AccordionToggleProps> = ({
  children,
  disabled = false,
  showArrow = !disabled,
  styles = defaultStyles,
  className = "",
  baseClass = `${styles.acessLink} ${styles.keyHeading}`,
  openClass = "",
  openedText = null,
  closedText = null,
  ...props
}) => {
  const currentEventKey = useContext(AccordionContext);
  const isOpen = currentEventKey === props.eventKey;
  return (
    <BsAccordion.Toggle
      {...(BsAccordion.Toggle.defaultProps || {})}
      aria-disabled={disabled}
      className={`${baseClass} ${className}`}
      data-collapsed={!isOpen}
      {...props}
    >
      {children}
      {isOpen && openedText}
      {!isOpen && closedText}
      {showArrow && (
        <span
          className={`${styles.panelArrow} ${isOpen ? "" : openClass}`}
          tabIndex={0}
          title="more options"
          role="button"
        />
      )}
    </BsAccordion.Toggle>
  );
};

export const AccordionCollapse: React.FC<AccordionCollapseProps> = (props) => (
  <BsAccordion.Collapse {...(BsAccordion.Collapse.defaultProps || {})} {...props} />
);

export { AccordionContext };
